import { render } from "./Images-tab-page.vue?vue&type=template&id=49e581c5&scoped=true"
import script from "./Images-tab-page.vue?vue&type=script&lang=js"
export * from "./Images-tab-page.vue?vue&type=script&lang=js"

import "./Images-tab-page.vue?vue&type=style&index=0&id=49e581c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e581c5"]])

export default __exports__